// @flow
import React, { useRef } from 'react';
import './questionContainer.scss';
import QuestionOptionsLibrary from '../../QuestionOptionsLibrary/QuestionOptionsLibrary';
import { sanitiseHTML } from '../../../../legacy/utils/helpers';
import InfoMessage from '../../QuestionOptionsLibrary/components/InfoMessage/InfoMessage';
import { QuestionsUniqueKeys } from 'src/containers/QuestionnaireParent/QuestionnaireEnum';
import { Typography } from 'src/latest/src/components';
import { noop } from 'react-bootstrap-typeahead/types/utils';
type Props = {
  question: object,
  questionTitle: string,
  questionDescription: string,
  setUploading: any,
  isFileTypeInvalid: Boolean,
  setIsFileTypeInvalid: any,
  handleOnclick: Function,
  setIsMatchAssistance?: (isMatchAssistance: boolean) => void,
  onStripeCardStatusChange?: (hasCard: boolean) => void,
  onStripeCardFormValidationChange?: (isValid: boolean) => void,
  onStripeProcessingChange?: (isProcessing: boolean) => void,
  stripePaymentRef?: any,
};

function QuestionContainer({
  questionTitle,
  questionDescription,
  question,
  setUploading,
  isFileTypeInvalid,
  setIsFileTypeInvalid,
  handleOnclick,
  setIsMatchAssistance = noop,
  onStripeCardStatusChange,
  onStripeCardFormValidationChange,
  onStripeProcessingChange,
  stripePaymentRef,
}: Props): React$Element<any> {
  const pageName = questionTitle;
  const questionContainer = useRef(); // temp for demo

  return (
    <div
      ref={questionContainer}
      id={question.id}
      className={`question-container ${question.id} ${question.unique_key}`}
      key={question.id}
    >
      {question?.title && question?.metadata?.hide_question_title !== 'true' && (
        <div className="question-title-container">
          {questionTitle && (
            <div
              className={
                question?.info_message
                  ? 'd-flex justify-content-center align-items-center'
                  : ''
              }
            >
              <Typography
                className={`${pageName?.replace(
                  / /g,
                  '-',
                )} mb-3 mt-0 text-center`}
              >
                {sanitiseHTML(questionTitle) || ''}
              </Typography>
              {question?.info_message &&
                question?.unique_key ===
                  QuestionsUniqueKeys.patientLocation && (
                  <div style={{ marginLeft: '8px', marginTop: '-16px' }}>
                    <InfoMessage text={question?.info_message} />
                  </div>
                )}
            </div>
          )}
          {questionDescription && (
            <Typography
              className={`${pageName?.replace(
                / /g,
                '-',
              )} mt-3 mb-4 text-center`}
            >
              {sanitiseHTML(questionDescription) || ''}
            </Typography>
          )}
        </div>
      )}
      <QuestionOptionsLibrary
        question={question}
        setUploading={setUploading}
        isFileTypeInvalid={isFileTypeInvalid}
        setIsFileTypeInvalid={setIsFileTypeInvalid}
        handleOnclick={handleOnclick}
        setIsMatchAssistance={setIsMatchAssistance}
        onStripeCardStatusChange={onStripeCardStatusChange}
        onStripeCardFormValidationChange={onStripeCardFormValidationChange}
        onStripeProcessingChange={onStripeProcessingChange}
        stripePaymentRef={stripePaymentRef}
      />
    </div>
  );
}

// const Questionnaire: any = withLoading<React$Element<Props>>(QuestionPage);

export default QuestionContainer;
